<script>
	import pubsub from 'events/pubsub';

	export default {
		props: ['edit-account', 'original-account'],

		methods: {
			success() {
				pubsub.publish('message-success', 'Account modified');
			}
		}
	};
</script>
<template>
	<div class="main-content wrapper">
		<user-setup-form
			:submit-button-text="'Save Changes'"
			:success-handler="success"
			:original-account="originalAccount"></user-setup-form>
	</div>
</template>
